import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=434a913c&scoped=true&"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmResetPassword.vue?vue&type=style&index=0&id=434a913c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a913c",
  null
  
)

export default component.exports